import React from "react";
import { Card, Typography, Grid, Box } from "@mui/material";

const ApproverFlow = ({ approvers, currentIndex }) => {
  return (
    <Grid container spacing={2} sx={{ mt: 2 }}>
      {approvers?.map((approver, index) => (
        <Grid
          item
          xs={12}
          sm={6}
          md={3}
          lg={2.2}
          key={index}
        >
          <ApproverCard
            approver={approver}
            index={index}
            isCurrent={index === currentIndex}
            isLast={index === approvers.length - 1}
          />
        </Grid>
      ))}
    </Grid>
  );
};

const ApproverCard = ({ approver, isCurrent }) => {
  const getStatusColor = () => {
    if (approver?.Approved_flg) return "#3BD2A2";
    if (isCurrent) return "#F39711";
    return "#CCCCCC";
  };

  return (
    <Card
      sx={{
        p: 2,
        height: "100%",
        border: isCurrent ? "1px solid #3BD2A2" : "1px solid #0000002d",
        boxShadow: "none",
        borderRadius: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <Typography variant="h5" textAlign="center" noWrap>
        {approver?.Approvername}
      </Typography>

      <Typography
        variant="body2"
        textAlign="center"
        sx={{ mt: 1 }}
      >
        {approver?.ApproverRole}
      </Typography>

      <Typography
        variant="body2"
        textAlign="center"
        sx={{ mt: 1, color: getStatusColor() }}
      >
        {approver?.Approved_flg ? "Approved" : "Pending"}
      </Typography>
    </Card>
  );
};

export default ApproverFlow;
